import work1 from "../Assets/Images/OurWorks/Work1.png";
import work2 from "../Assets/Images/OurWorks/Work2.png";
import work3 from "../Assets/Images/OurWorks/Work3.png";
import work4 from "../Assets/Images/OurWorks/Work4.png";

import why1 from "../Assets/Images/services/Why1.png";
import why2 from "../Assets/Images/services/Why2.png";
import why3 from "../Assets/Images/services/Why3.png";
import why4 from "../Assets/Images/services/Why4.png";

import webw1 from "../Assets/Images/services/WebDevelopment/webw1.png";
import webw2 from "../Assets/Images/services/WebDevelopment/webw2.png";
import webw3 from "../Assets/Images/services/WebDevelopment/webw3.png";
import webw4 from "../Assets/Images/services/WebDevelopment/webw4.png";

import digw1 from "../Assets/Images/services/DigitalMarketing/digw1.png";
import digw2 from "../Assets/Images/services/DigitalMarketing/digw2.png";
import digw3 from "../Assets/Images/services/DigitalMarketing/digw3.png";
import digw4 from "../Assets/Images/services/DigitalMarketing/digw4.png";

import appw1 from "../Assets/Images/services/AppDevelopment/appw1.png";
import appw2 from "../Assets/Images/services/AppDevelopment/appw2.png";
import appw3 from "../Assets/Images/services/AppDevelopment/appw3.png";
import appw4 from "../Assets/Images/services/AppDevelopment/appw4.png";
import appw5 from "../Assets/Images/services/AppDevelopment/appw5.png";


import figmaImg from '../Assets/Images/services/figma.png';
import framerImg from '../Assets/Images/services/Framer.png';
import behanceImg from '../Assets/Images/services/Behance.png';
import dribbbleImg from '../Assets/Images/services/Dribble.png';
import photoshopImg from '../Assets/Images/services/Photshop.png';
import adobeXDImg from '../Assets/Images/services/AdobeXD.png';

import googleAdsImg from '../Assets/Images/DIgitalMarketing/GoogleAds.png';
import linkedInAdsImg from '../Assets/Images/DIgitalMarketing/LinkedInAds.png';
import metaAdsImg from '../Assets/Images/DIgitalMarketing/MetaAds.png';
import youTubeAdsImg from '../Assets/Images/DIgitalMarketing/YouTubeAds.png';


import strategyImg from "../Assets/Images/OurServices/strategy.png";
import webdevImg from "../Assets/Images/OurServices/webdev.png";
import marketingImg from "../Assets/Images/OurServices/marketing.png";
import contentImg from "../Assets/Images/OurServices/content.png";

import img1 from "../Assets/Images/Testimonial/team.png";

import logo from "../Assets/Images/Logo/Ideal_Corporate_Services.png";
export const brandName = "Ideal Corporate Services";
export const brandLogo = logo;



//Homepage About Section Content

export const aboutusContent = [
  "Best Web Design Company in Chennai & iOS App Development Company in Chennai",
  ` At ${brandName}, we partner with businesses to unlock their full potential through intuitive technology, user-centric design, and data-driven strategies.`,
  "We do this through a comprehensive suite of services designed to fuel your growth and elevate your brand.",
  "We focus on delivering practical and innovative solutions.",
  "We're here to turn your ideas into impactful realities.",
  "You're our trusted partners in navigating the digital landscape.",
];

//Homepage Hero Section Content

export const heroContent = [
  "Digital Growth-as-a-Service",
  "Web Designing Company in Chennai | Transforming Ideas into Digital Realities - Idealcorp",
  "Empowering your business with innovative solutions and user-focused designs.",
  "Let's Collaborate",
  "Fast Delivery",
  "Scalable Strategies",
  "Transparent Pricing",
];

//Homepage How We Work Section Content

export const HowWeWorkContent = [
  {
    sequence: "01.",
    title: "Strategic Planning & Discovery",
    description:
      "We work with you to understand your goals and craft a solid digital roadmap.",
  },
  {
    sequence: "02.",
    title: "Creative Design & Development",
    description:
      "Our team turns ideas into reality with beautiful, functional, and responsive websites.",
  },
  {
    sequence: "03.",
    title: "Continuous Improvement",
    description:
      "We monitor and refine your online presence to ensure long-term success.",
  },
];

//Homepage Services Marquee Section Content

export const servicesContent = [
  "WEB DEVELOPMENT",
  "UI UX DESIGNING",
  "MOBILE APP DEVELOPMENT",
  "DIGITAL MARKETING",
  "SEO & Performance Marketing",
  "Social Media Management",
  "Branding & Visual Design",
  "Custom Web Applications",
  "SMs marketing",
  "Data Analytics",
];

//Homepage Strength Stats Section Content

export const strengthStatsContent = [
  "Our Strength Expressed in Numbers",
  `At ${brandName}, numbers reflect our commitment to exceptional digital experiences and tangible results.`,
  "42K+",
  "Satisfied clients",
  "85%",
  "Customer retention",
  "75K+",
  "Successful projects",
  "30+",
  "Industry awards",
];

//Homepage Brand Marquee Section Content

export const brandLogosContent = [
  [
    {
      name: "Airbnb",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_Bélo.svg",
    },
    {
      name: "Amazon",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
    },
    {
      name: "AWS",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
    },
    {
      name: "Android",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg",
    },
    {
      name: "Apple",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
    },
    {
      name: "ASUS",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6e/AsusTek_Computer_Logo.svg",
    },
    {
      name: "Booking",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Booking.com_logo.svg",
    },
    {
      name: "Etsy",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4f/Etsy_logo.svg",
    },
    {
      name: "FILA",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4d/Fila_logo.svg",
    },
    {
      name: "Flipkart",
      url: "https://1000logos.net/wp-content/uploads/2021/06/Flipkart-logo.png",
    },
    {
      name: "Google Pay",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Google_Pay_Logo.svg",
    },
    {
      name: "Honda",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Honda_Logo.svg",
    },
  ],
  [
    {
      name: "IBM",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg",
    },
    {
      name: "jQuery",
      url: "https://upload.wikimedia.org/wikipedia/en/9/9e/JQuery_logo.svg",
    },
    {
      name: "Lenovo",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/29/Lenovo_logo_2015.svg",
    },
    {
      name: "MasterCard",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg",
    },
    {
      name: "Microsoft",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg",
    },
    {
      name: "MongoDB",
      url: "https://webimages.mongodb.com/_com_assets/cms/mongodb_logo1-76twgcu2dm.png",
    },
    {
      name: "Netflix",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg",
    },
    {
      name: "Nike",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a6/Logo_NIKE.svg",
    },
    {
      name: "Nokia",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/00/Nokia_wordmark.svg",
    },
    {
      name: "PayPal",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg",
    },
    {
      name: "Pepsi",
      url: "https://upload.wikimedia.org/wikipedia/en/6/6d/Pepsi_logo_2014.svg",
    },
    {
      name: "Python",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg",
    },
  ],
  [
    {
      name: "Samsung",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg",
    },
    {
      name: "Slack",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/76/Slack_Icon.png",
    },
    {
      name: "Sony",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/20/Sony_Logo.svg",
    },
    {
      name: "SpaceX",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/de/SpaceX-Logo.svg",
    },
    {
      name: "Spotify",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/19/Spotify_logo_without_text.svg",
    },
    {
      name: "TikTok",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a9/TikTok_logo.svg",
    },
    {
      name: "Tinder",
      url: "https://upload.wikimedia.org/wikipedia/en/8/8c/Tinder_Logo.svg",
    },
    {
      name: "Walmart",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ca/Walmart_logo.svg",
    },
    {
      name: "Windows",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/48/Windows_logo_-_2021.svg",
    },
    {
      name: "WordPress",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/20/WordPress_logo.svg",
    },
    {
      name: "Adidas",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/20/Adidas_Logo.svg",
    },
  ],
];

//Homepage Our Works Section Content
export const OurworksContent = [
  {
    title: "TNPCB (Tamil Nadu Pollution Control Board)",
    description:
      "We Developed An Intuitive, User-Friendly Platform For TNPCB To Streamline Environmental Consent Management And Information Dissemination.",
    image: work1,
    gradient: "linear-gradient(135deg, #e6f2d4, #d9f1e4)",
    url:"/works/tnpcb",
  },
  {
    title: "Mahalakshmi Diagnostics Center",
    description:
      "A Modern, Patient-Centric Website For HMDS Diagnostics. Complete With Online Appointment Booking, Service Overviews And Advanced UI/UX Design.",
    image: work2,
    gradient: "linear-gradient(135deg, #e2f2ff, #e3e1fc)",
    url:"/works/mahalakshmi",
  },
  {
    title: "IYYAN DECORS",
    description:
      "We Developed An Intuitive, User-Friendly Platform For NPCB To Streamline Environmental Consent Management And Information Dissemination.",
    image: work3,
    gradient: "linear-gradient(135deg, #fbe8e8, #fbdcdc)",
    url:"/works/decors",
  },
  {
    title: "Jaya Colleges – Complete Digital Ecosystem",
    description:
      "We Built And Maintain A Fully Responsive Digital Platform For All Jaya Group Of Colleges – From Arts & Science To Engineering, Paramedical, Education, Commerce, LLB – And Admissions Processes Together In One Place.",
    image: work4,
    gradient: "linear-gradient(135deg, #d7f8dd, #d6f6e6)",
    url:"/works/jaya-colleges",
  },
];

//Homepage Our Services Section Content

export const services = [
  {
    id: 1,
    title: "Web Development",
    defaultText:
      "Custom Websites Built for Performance & Scale. We build responsive, high-speed websites tailored to your business goals with seamless functionality across devices.",
    hoverText:
      "Build lightning-fast, responsive websites with CMS integrations and optimized UI/UX.\n🔹 Custom landing pages\n🔹 Admin panel development\n🔹 SEO-ready architecture",
    image: strategyImg, 
  },
  {
    id: 2,
    title: "Software Development",
    defaultText:
      "Flexible Software for Every Business Need. From internal tools to enterprise systems, we build secure, scalable software to streamline your operations.",
    hoverText:
      "Design tailored software solutions that automate tasks and enhance business efficiency.\n🔹 Custom CRMs & ERPs\n🔹 Web & SaaS platforms\n🔹 Third-party integrations",
    image: contentImg, 
  },
  {
    id: 3,
    title: "Mobile App Development",
    defaultText:
      "Mobile-First Products That Drive Engagement. Create sleek, intuitive apps for iOS and Android that deliver seamless experiences on every device.",
    hoverText:
      "We develop cross-platform apps with compelling UI/UX and robust performance.\n🔹 Native & hybrid development\n🔹 UI design tailored for mobile\n🔹 App store launch & support",
    image: webdevImg, 
  },
  {
    id: 4,
    title: "SMS Integration",
    defaultText:
      "Bulk Messaging for Modern Communication. Reach customers with timely alerts, OTPs, and promos using secure SMS gateways.",
    hoverText:
      "Automate communications with bulk SMS delivery and seamless system integration.\n🔹 Transactional & promotional SMS\n🔹 API for websites/apps\n🔹 Campaign performance tracking",
    image: contentImg, 
  },
  {
    id: 5,
    title: "Digital Marketing",
    defaultText:
      "Visibility That Converts. Run campaigns across platforms to build awareness, generate leads, and boost revenue.",
    hoverText:
      "Reach, engage, and convert with powerful performance marketing strategies.\n🔹 SEO, Google Ads, Social Media\n🔹 Retargeting & funnels\n🔹 ROI tracking in real-time",
    image: marketingImg, 
  },
  {
    id: 6,
    title: "Data Analytics",
    defaultText:
      "Turn Data into Smarter Decisions. Visualize performance, understand behavior, and make decisions powered by insights.",
    hoverText:
      "Leverage data dashboards and reports that drive business growth.\n🔹 User behavior tracking\n🔹 Marketing performance insights\n🔹 Predictive analytics tools",
    image: webdevImg, 
  },
];



 export const testimonials = [
    {
      description:
        " Ideal transformed our old website into a modern, patient-friendly platform. The UI/UX is incredibly smooth, and our online bookings have increased by 40%! Their team understood our vision from day one and delivered beyond expectations",
      name: "Dr. Smith",
      image: img1,
      designation: "Orthopedic Surgeon",
      rating: 5,
    },
    {
      description:
        " Ideal transformed our old website into a modern, patient-friendly platform. The UI/UX is incredibly smooth, and our online bookings have increased by 40%! Their team understood our vision from day one and delivered beyond expectations",
      name: "Dr. Smith",
      image: img1,
      designation: "Orthopedic Surgeon",
      rating: 5,
    },
    {
      description:
        " Ideal transformed our old website into a modern, patient-friendly platform. The UI/UX is incredibly smooth, and our online bookings have increased by 40%! Their team understood our vision from day one and delivered beyond expectations",
      name: "Dr. Smith",
      image: img1,
      designation: "Orthopedic Surgeon",
      rating: 5,
    },
    {
      description:
        " Ideal transformed our old website into a modern, patient-friendly platform. The UI/UX is incredibly smooth, and our online bookings have increased by 40%! Their team understood our vision from day one and delivered beyond expectations",
      name: "Dr. Smith",
      image: img1,
      designation: "Orthopedic Surgeon",
      rating: 5,
    },
  ];


  // FAQ

  export const faqData = [
  {
    question: "What services do you offer?",
    answer:
      "We offer web/app development, custom software, digital marketing, SMS integration, and data analytics.",
  },
  {
    question: "Do you work with startups and enterprises?",
    answer:
      "Yes, we work with businesses of all sizes across industries.",
  },
  {
    question: "How can I get started?",
    answer:
      "Contact us via email or our Contact page — we’ll schedule a call to begin.",
  },
  {
    question: "Do you provide both design and development?",
    answer:
      "Yes, we handle everything from UI/UX design to full-stack development.",
  },
  {
    question: "Do you offer support after project launch?",
    answer:
      "Absolutely. We provide maintenance, updates, and performance monitoring.",
  },
];


// Faq for UI UX page

export const uiuxFaqData = [
  {
    question: "What is included in your UI/UX design service?",
    answer:
      "Our service includes user research, wireframes, interactive prototypes, visual design, and usability testing to ensure intuitive and engaging experiences.",
  },
  {
    question: "Do you design for both web and mobile apps?",
    answer:
      "Yes, we create responsive web designs and tailored mobile app interfaces for iOS and Android platforms.",
  },
  {
    question: "How do you ensure the design meets user needs?",
    answer:
      "We follow a user-centered design approach, conducting research, persona development, and usability tests to align the design with real user expectations.",
  },
  {
    question: "Can you redesign our existing app or website?",
    answer:
      "Absolutely. We specialize in redesigning outdated or underperforming products to improve usability, aesthetics, and overall customer experience.",
  },
  {
    question: "Do you deliver design files in Figma or other tools?",
    answer:
      "Yes, we typically deliver in Figma, but we can also provide assets in Adobe XD, Sketch, or other formats based on your preference.",
  },
  {
    question: "Do you also handle development after design?",
    answer:
      "Yes, we offer full-stack development alongside UI/UX design, ensuring seamless transition from design to functional product.",
  },
];



// services ui ux page

export const deliverablesuiux = [
  {
    id: "01",
    title: "Strategy-Backed Personas & User Journeys",
    subtitle: "We Don't Just Guess Who Your Users Are—We Define Them.",
    description:
      "We Create Deep, Research-Driven Personas And Map Out Their Digital Journey. This Helps Ensure Every Touchpoint, Click, And Scroll Is Purposeful And Aligned With Your Product Goals.",
  },
  {
    id: "02",
    title: "Wireframes & Prototypes",
    subtitle: "From Concept To Interactive Reality.",
    description:
      "We Build Detailed Wireframes And Interactive Prototypes That Allow You To Test And Refine Your Product Before Development Begins.",
  },
  {
    id: "03",
    title: "Visual Design & Branding",
    subtitle: "Making Your Product Beautiful And Memorable.",
    description:
      "We Create Stunning Visual Designs That Not Only Look Amazing But Also Reinforce Your Brand Identity And Create Emotional Connections With Users.",
  },
  {
    id: "04",
    title: "Usability Testing & Optimization",
    subtitle: "Continuous Improvement Based On Real User Feedback.",
    description:
      "We Test Your Product With Real Users And Provide Actionable Insights To Continuously Improve The User Experience And Increase Conversions.",
  },
];

export const featuresuiux = [
  {
    title: "Strategy Meets Impact",
    desc: "We Don’t Just Design—We Align Your Product Goals With What Your Users Actually Want. Our Strategic Approach Ensures Every Screen Serves A Purpose. From Day One, You’ll Know Exactly Where We’re Headed And Why It Matters.",
    img: why1
  },
  {
    title: "Real Designers. Real Results.",
    desc: "Our Experienced UI/UX Team Has Crafted Digital Experiences Across Industries—From Startups To Scale-Ups. We Know Their Hurdles. And We Help You Avoid Them While Building Interfaces Users Love (And Remember).",
    img: why2
  },
  {
    title: "Built On True Collaboration",
    desc: "Working With Us Feels Like Working With Your Own Dedicated Team. We Bring Transparency, Share Our Design Process, Run Calibrations In Real Time—Because The Best Products Are Never Built Solo.",
    img: why3
  },
  {
    title: "Scale–Ready, Future–Proof",
    desc: "Whether You’re Building A Product, Feature, Or Platform, We Help You Move From Concept To Development Seamlessly. With Scalable Design Systems, And Aligned Content—Design That’s Built To Evolve With Your Product.",
    img: why4
  }
];

export const toolsdig = [
  { name: "LinkedIn Ads", img: linkedInAdsImg },
  { name: "Google Ads", img: googleAdsImg },
  { name: "YouTube Ads", img: youTubeAdsImg },
  { name: "Meta Ads", img: metaAdsImg }
];


export const toolsuiux = [
  { name: "Figma", img: figmaImg },
  { name: "Framer", img: framerImg },
  { name: "Behance", img: behanceImg },
  { name: "Dribbble", img: dribbbleImg },
  { name: "Photoshop", img: photoshopImg },
  { name: "Adobe XD", img: adobeXDImg }
];



export const toolsweb = [
  { name: "Figma", img: figmaImg },
  { name: "Framer", img: framerImg },
  { name: "Behance", img: behanceImg },
  { name: "Dribbble", img: dribbbleImg },
  { name: "Photoshop", img: photoshopImg },
  { name: "Adobe XD", img: adobeXDImg }
];


// QualityService.  

export const deliverablesWebDevelopment = [
  {
    id: "01",
    title: "Strategy-Led Tech Stack",
    subtitle: "Smart Tech Choices for Long-Term Wins.",
    description:
      "Your tech decisions shouldn’t be trends—they should be tactical. We define the right stack based on performance, scalability, and long-term growth.",
  },
  {
    id: "02",
    title: "High-Performance Code",
    subtitle: "Clean, Fast, and Reliable Codebase.",
    description:
      "We write robust, maintainable code that powers seamless user experiences and scales effortlessly with your growth.",
  },
  {
    id: "03",
    title: "Full-Stack Functionality",
    subtitle: "End-to-End Development, Covered.",
    description:
      "From CMS to custom APIs and dashboards, we build the complete ecosystem your brand needs to operate efficiently.",
  },
  {
    id: "04",
    title: "Secure, SEO-Ready Launch",
    subtitle: "Built for Visibility and Protection.",
    description:
      "Optimized pages, structured data, and airtight security—all set for visibility and success from day one.",
  },
];

export const featuresweb = [
  {
    title: "Strategic Engineering",
    desc: "We align web builds with your business goals, ensuring each line of code is written with purpose and scalability in mind.",
    img: webw1
  },
  {
    title: "Real Developers. Real Solutions.",
    desc: "From startup MVPs to enterprise systems, our engineers bring deep experience and rapid problem-solving to every stage of development.",
    img: webw2
  },
  {
    title: "Built On True Collaboration",
    desc: "We work transparently with your team. From project sprints to reviews, you're always in the loop—no siloed dev processes here.",
    img: webw3
  },
  {
    title: "Built to Scale",
    desc: "We use modular architecture, cloud-native builds, and future-proof stacks—so your business can grow without tech limitations.",
    img: webw4
  }
];

// digital marketing service

export const deliverablesdig = [
  {
    id: "01",
    title: "Strategy-Led Campaigns",
    subtitle: "Smart Planning for Scalable Growth.",
    description:
      "We start every engagement with research-backed strategy—defining KPIs, audience personas, platforms, and messaging for scalable results.",
  },
  {
    id: "02",
    title: "Conversion-Optimized Creatives",
    subtitle: "Designs That Drive Action.",
    description:
      "From ad copy to visuals, every element is crafted to drive action—built around platform best practices and brand identity.",
  },
  {
    id: "03",
    title: "Full-Funnel Execution",
    subtitle: "End-to-End Campaign Management.",
    description:
      "We manage everything from awareness to conversion—running campaigns across Meta, Google, LinkedIn, and more with retargeting in place.",
  },
  {
    id: "04",
    title: "Real-Time Reporting & SEO Integration",
    subtitle: "Track Performance. Optimize Constantly.",
    description:
      "We deliver transparent analytics, keyword performance, and SEO-based improvements so your campaigns stay visible and impactful.",
  },
];

export const featuresdig = [
  {
    title: "Data-Driven Campaign Strategy",
    desc: "We don’t shoot in the dark. Every campaign starts with research-backed audience insights, competitor analysis, and clear KPIs to ensure ROI from day one.",
    img: digw1
  },
  {
    title: "Real Marketers. Real Results",
    desc: "From Meta Ads to SEO, our in-house team of experts executes campaigns tailored to your industry, using real-time data and platform expertise to maximize impact.",
    img: digw2
  },
  {
    title: "Collaboration That Converts",
    desc: "We work hand-in-hand with your internal team for approvals, content alignment, and brand voice—ensuring seamless execution and fast pivots when needed.",
    img: digw3
  },
  {
    title: "Scalable Growth Systems",
    desc: "Our campaigns are designed for scale—from retargeting systems to automated email flows and optimized landing pages—so your business never outgrows your marketing.",
    img: digw4
  }
];



// Mobile app Development service

export const deliverablesapp = [
  {
    id: "01",
    title: "Strategy-Driven App Planning",
    subtitle: "User-Centric & Scalable Foundations.",
    description:
      "We start with user-centric strategy—defining app goals, target audience, required features, tech stack, and platform (iOS, Android, Hybrid) to ensure maximum impact & scalability.",
  },
  {
    id: "02",
    title: "Intuitive UI/UX Design",
    subtitle: "Clear, Engaging, and Device-Friendly.",
    description:
      "Every interface is designed with clarity, flow & engagement in mind—from wireframes to final visuals—ensuring easy navigation & delightful user experiences on all devices.",
  },
  {
    id: "03",
    title: "Robust App Development",
    subtitle: "Fast, Secure & Scalable Codebase.",
    description:
      "We build secure, fast, and scalable apps using modern frameworks like Flutter, React Native, Kotlin, and Swift—with seamless API integrations, database handling, and offline support.",
  },
  {
    id: "04",
    title: "Launch, Support & Analytics",
    subtitle: "Ongoing Stability & Optimization.",
    description:
      "Post-deployment, we handle store publishing, real-time monitoring, bug fixes, feature updates, and performance analytics—ensuring your app remains fast, stable, and engaging.",
  },
];


export const featuresapp = [
  {
    title: "Complete App Ownership",
    desc: "You get full rights to your mobile application—from source code to design assets. We work under strict NDAs and hand over everything upon completion.",
    img: appw1,
  },
  {
    title: "Transparent Pricing Model",
    desc: "We provide clear cost estimates up front. No hidden charges—even if the development timeline shifts due to unavoidable factors.",
    img: appw2,
  },
  {
    title: "Support for Non-Tech Founders",
    desc: "You don’t need to be a developer to launch an app with us. We simplify the journey for founders from all backgrounds.",
    img: appw3,
  },
  {
    title: "Proven Processes & Timelines",
    desc: "With years of experience and many successful apps delivered, our proven process ensures speed, clarity, and accountability.",
    img: appw4,
  },
  {
    title: "Shared Success Mindset",
    desc: "We define KPIs before we build and track them post-launch—because your app’s growth is our responsibility too.",
    img: appw5, // You can update this to a new image if desired
  },
];


export const toolsapp = [
  { name: "Figma", img: figmaImg },
  { name: "Framer", img: framerImg },
  { name: "Behance", img: behanceImg },
  { name: "Dribbble", img: dribbbleImg },
  { name: "Photoshop", img: photoshopImg },
  { name: "Adobe XD", img: adobeXDImg }
];